<template>
  <main v-if="dataFlowStep.length">
    <v-card class="pa-3">
      <v-row style="background-color: #BEE7F8;">
        <v-col cols="12" class="text-left pt-10 mb-3" style="font-size: 20px;">
          <strong style="font-size: 24px;">{{
            dataFlowStep[0].flowName
          }}</strong>
        </v-col>
        <v-col cols="12">
          <v-row>
            <v-col class="pt-0" cols="5"
              ><b style="font-size: 20px;">ชื่อผู้นัดหมาย</b></v-col
            >
            <v-col class="pt-0" cols="7" style="font-size: 20;">{{ NameData }}</v-col>
            <v-col class="pt-0" cols="5"
              ><b style="font-size: 20px;">โทร</b></v-col
            >
            <v-col class="pt-0" cols="7" style="font-size: 20;">{{ TelData }}</v-col>
            <v-col class="pt-0" cols="5"
              ><b style="font-size: 20px;">ชื่อผู้รับบริการ</b></v-col
            >
            <v-col class="pt-0" cols="7" style="font-size: 20;">{{ NameData2 }}</v-col>
            <v-col class="pt-0" cols="5"
              ><b style="font-size: 20px;">โทร</b></v-col
            >
            <v-col class="pt-0" cols="7" style="font-size: 20;">{{ TelData2 }}</v-col>
            <v-col class="pt-0" cols="5"
              ><b style="font-size: 20px;">ผู้รับผิดชอบ</b></v-col
            >
            <v-col class="pt-0" cols="7" style="font-size: 20;">{{
              dataJobLog[dataJobLog.length - 1].empStep
            }}</v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-card>
    <v-card-text class="pa-4">
      <v-row>
        <v-cols cols="12" class="w-100">
          <div>
            <v-timeline
              align-top
              dense
              v-for="(itemStep, indexStep) in dataFlowStep"
              :key="indexStep"
            >
              <v-timeline-item
                :color="
                  itemStep.stepId === (chkCloseJob !== false ? itemJob[0].stepId : itemJob[itemJob.length-1].stepId) ? '#BEE7F8' : '#CCCAD0'
                "
                small
              >
                <v-row class="pt-1">
                  <v-col cols="4">
                    <strong
                      v-if="
                        dataJobLog.filter(
                          (Ilog, inLog) =>
                            Ilog.jobNo === jobNo &&
                            Ilog.stepId === itemStep.stepId
                        ).length > 0
                      "
                      style="font-size: 18;"
                    >
                      {{
                        dataJobLog.filter(
                          (Ilog, inLog) =>
                            Ilog.jobNo === jobNo &&
                            Ilog.stepId === itemStep.stepId
                        )[0].CREATE_DATE_TIME
                      }}
                    </strong>
                  </v-col>
                  <v-col cols="8">
                    <strong style="font-size: 18;">{{ itemStep.stepTitle }}</strong>
                    <div
                      class="text-caption"
                      v-if="
                        dataJobLog.filter(
                          (Ilog, inLog) =>
                            Ilog.jobNo === jobNo &&
                            Ilog.stepId === itemStep.stepId
                        ).length > 0
                      "
                      style="font-size: 16;"
                    >
                      {{
                        covDate(
                          dataJobLog.filter(
                            (Ilog, inLog) =>
                              Ilog.jobNo === jobNo &&
                              Ilog.stepId === itemStep.stepId
                          )[0].showDate
                        )
                      }}
                    </div>
                  </v-col>
                </v-row>
              </v-timeline-item>
            </v-timeline>
          </div>
        </v-cols>
      </v-row>
      </v-card-text>
  </main>
</template>

<script>
import axios from 'axios' // api
import moment from 'moment'
export default {
  data () {
    return {
      codeColor: [
        'rgb(142, 202, 230)',
        'rgb(33, 158, 188)',
        'rgb(2, 48, 71)',
        'rgb(241, 91, 76)',
        'rgb(255, 183, 3)',
        'rgb(251, 133, 0)',
        'rgb(61,90,128)',
        'rgb(152,193,217)',
        'rgb(224,251,252)',
        'rgb(255,212,91)',
        'rgb(238,108,77)',
        'rgb(41,50,65)'
      ],
      monthNamesThai: [
        '',
        'ม.ค',
        'ก.พ',
        'มี.ค',
        'เม.ย',
        'พ.ค',
        'มิ.ย',
        'ก.ค',
        'ส.ค',
        'ก.ย',
        'ต.ค',
        'พ.ย',
        'ธ.ค'
      ],
      dataLineConfig: {},
      shopId: '',
      jobNo: '',
      flowId: '',
      NameData: '',
      TelData: '',
      NameData2: '',
      TelData2: '',
      timelineitem: [],
      itemStep: [],
      dataFlowStep: [],
      dataJobLog: [],
      itemJob: [],
      empStepId: '',
      chkCloseJob: false
    }
  },
  async mounted () {
    this.shopId = this.$route.query.shopId
    this.jobNo = this.$route.query.jobNo
    this.flowId = this.$route.query.flowId
    console.log('this.flowId : ', this.flowId)
    await this.getData()
    await this.getFlowStep()
    await this.getJobLog()
    await this.getJob()
    await this.checkEmpJob()
  },
  methods: {
    covDate (e) {
      try {
        const d = e.split('-')
        return (
          d[0] + '/' + d[1].padStart(2, '0') + '/' + (parseInt(d[2]) + 543)
        )
      } catch (err) {
        console.log(err)
        return ''
      }
    },
    async getJob () {
      const resp = await axios.get(
        this.DNS_IP + '/job/get?jobNo=' + this.jobNo
      )
      if (resp.data.length > 0) {
        console.log('resp : job : ', resp)
        for await (const i of resp.data) {
          if (i.fieldName.trim() === 'ชื่อ') {
            this.NameData = i.fieldValue
          } else if (i.fieldName.trim() === 'เบอร์โทร') {
            this.TelData = i.fieldValue
          } else if (i.fieldName.trim() === 'ชื่อผู้รับบริการ') {
            this.NameData2 = i.fieldValue
          } else if (i.fieldName.trim() === 'เบอร์โทรผู้รับบริการ') {
            this.TelData2 = i.fieldValue
          }
          this.empStepId = i.empStepId
        }
      } else {
        const resp = await axios.get(
          this.DNS_IP + '/job/getDelete?jobNo=' + this.jobNo
        )
        if (resp.data.length > 0) {
          console.log('resp : job : ', resp)
          for await (const i of resp.data) {
            if (i.fieldName.trim() === 'ชื่อ') {
              this.NameData = i.fieldValue
            } else if (i.fieldName.trim() === 'เบอร์โทร') {
              this.TelData = i.fieldValue
            }
            this.empStepId = i.empStepId
          }
        }
        this.chkCloseJob = true
      }
    },
    async getData () {
      console.log('this.shopId  : ', this.shopId)
      console.log('this.jobNo  : ', this.jobNo)
      this.timelineitem = []
      try {
        console.log(' >>> ', this.DNS_IP + '/job_logCloseJob/' + this.jobNo)
        const resp = await axios.get(
          this.DNS_IP + '/job_logCloseJob/' + this.jobNo
        )
        if (resp.data.length > 0) {
          for await (const d of resp.data) {
            let s = {}
            s.empStep = d.empStep
            s.endDate = d.endDate
            s.totalPrice = s.totalPrice
            s.DTCREATE_DATE = d.CREATE_DATE
            s.DTLAST_DATE = d.LAST_DATE
            s.stepTitle = d.totalPrice === null ? d.stepTitle : 'ปิดจ๊อบ'
            s.timediff = d.timediff
            s.LAST_USER_Name = d.LAST_USER_Name || d.LAST_USER
            s.Counttime = this.convertHMS(
              this.jsTimeDiff(d.CREATE_DATE, d.LAST_DATE)
            )
            s.totalPrice = d.totalPrice
            this.timelineitem.push(s)
          }
          console.log('this.timelineitem : ', this.timelineitem)
        }
      } catch (err) {
        console.log('err : ', err)
      }
    },
    async getJobLog () {
      this.dataJobLog = []
      if (this.jobLog_jobNo !== '') {
        let params =
          this.DNS_IP +
          '/job_log/get?shopId=' +
          this.shopId +
          '&flowId=' +
          this.flowId +
          '&jobNo=' +
          this.jobNo
        await axios
          .get(params)
          .then(response => {
            let rs = response.data
            if (rs.length > 0) {
              this.dataJobLog = rs
            }
            console.log('!!!!!!JOB_LOG', rs)
          })
          .catch(error => {
            console.log('error function addData : ', error)
          })
      } else {
        this.dataJobLog = []
      }
    },
    async getFlowStep () {
      console.log('shopId', this.shopId)
      console.log('this.selectFlow', this.selectFlow)
      this.itemStep = []
      let params =
        this.DNS_IP +
        '/flowStep/get?shopId=' +
        this.shopId +
        '&flowId=' +
        this.flowId
      console.log('params >>>', params)
      await axios
        .get(params)
        .then(response => {
          let rs = response.data
          console.log('rs >>>>>>>>>', rs)
          if (rs.length > 0) {
            this.dataFlowStep = rs
            rs.forEach(item => {
              let s = {}
              s.text = item.stepTitle
              s.value = item.stepId
              s.flowId = item.flowId
              this.itemStep.push(s)
            })
          }
          console.log('rs2', rs)
        })
        .catch(error => {
          console.log('error function addData : ', error)
        })
    },
    async checkEmpJob () {
      let urls = '/job/getList'
      if (this.chkCloseJob === true) {
        urls = '/job/getListDelete'
      }

      this.itemJob = []
      let params =
        this.DNS_IP +
        urls +
        '?shopId=' +
        this.shopId +
        '&empStep=' +
        this.empStepId +
        '&flowId=' +
        this.flowId
      await axios.get(params).then(async response => {
        let rs = response.data
        console.log('rs!!!!!!!!!', rs)
        if (rs.status === false) {
          this.itemJob = []
        } else {
          for (let i = 0; i < rs.length; i++) {
            let d = rs[i]
            if (d.userId !== null) {
              d.dataShow =
                d.dueDateD + ' ' + this.monthNamesThai[parseInt(d.dueDateM)]
              this.itemJob.push(d)
            }
          }
          console.log('checkIF!!!!!!!!!!!!Sort2', this.itemJob)
        }
      })
    },
    format_dateNotime (value) {
      if (value) {
        return moment(moment(new Date(value), 'DD/MM/YYYY').toDate()).format(
          'DD/MM/YYYY'
        )
        // return moment(String(value)).format('DD/MM/YYYY')
      }
    },
    momenTime (value) {
      if (value) {
        // return moment(String(value)).format('HH:mm')
        return moment(moment(new Date(value), 'HH:mm').toDate()).format(
          'HH:mm'
        )
      }
    },
    jsTimeDiff (Time1, Time2) {
      var oneday = 1000 * 60
      var defDate =
        (new Date(Time2).getTime() - new Date(Time1).getTime()) / oneday
      return defDate
    },
    convertHMS (value) {
      const sec = parseInt(value, 10) // convert value to number if it's string
      let hours = Math.floor(sec / 3600) // get hours
      let minutes = Math.floor((sec - hours * 3600) / 60) // get minutes
      let seconds = sec - hours * 3600 - minutes * 60 // get seconds
      // add 0 if value < 10; Example: 2 => 02
      if (hours < 10) {
        hours = '0' + hours
      }
      if (minutes < 10) {
        minutes = '0' + minutes
      }
      if (seconds < 10) {
        seconds = '0' + seconds
      }
      return hours + ':' + minutes + ':' + seconds // Return is HH : MM : SS
    }

    // async shareFlex () {
    //   let flex = {
    //     'type': 'flex',
    //     'altText': 'เช็คสถานะเรียลไทม์',
    //     'contents': {
    //       'type': 'bubble',
    //       'hero': {
    //         'type': 'image',
    //         'url': 'https://scontent.fbkk24-1.fna.fbcdn.net/v/t39.30808-6/302045589_382822067376928_3838082802657402137_n.jpg?_nc_cat=105&ccb=1-7&_nc_sid=6ee11a&_nc_eui2=AeHfECTxhcs1h_9hXNz8Wgzcmu1sRdcGePua7WxF1wZ4-6ark_Zl-tw1azFPbK9B4ig&_nc_ohc=tHlVHZq1jXUQ7kNvgHD5Ki2&_nc_ht=scontent.fbkk24-1.fna&_nc_gid=AIKF0FuITR5OfYScHYpq1cA&oh=00_AYCDYyQxQENuDNIn4-mgnNGHgz33ZiRJCNo5nfbWs56ELg&oe=6712FAE8',
    //         'size': 'full',
    //         'aspectRatio': '20:13',
    //         'aspectMode': 'fit',
    //         'action': {
    //           'type': 'uri',
    //           'uri': 'https://line.me/'
    //         },
    //         'offsetTop': '10px'
    //       },
    //       'body': {
    //         'type': 'box',
    //         'layout': 'vertical',
    //         'contents': [
    //           {
    //             'type': 'text',
    //             'text': 'ได้รับสิทธิ์การเข้าถึงข้อมูล',
    //             'weight': 'bold',
    //             'size': 'lg',
    //             'align': 'center'
    //           },
    //           {
    //             'type': 'text',
    //             'text': this.$route.query.fullName,
    //             'align': 'center',
    //             'size': 'lg',
    //             'margin': 'sm'
    //           }
    //         ]
    //       },
    //       'footer': {
    //         'type': 'box',
    //         'layout': 'vertical',
    //         'spacing': 'sm',
    //         'contents': [
    //           {
    //             'type': 'button',
    //             'style': 'primary',
    //             'height': 'sm',
    //             'action': {
    //               'type': 'uri',
    //               'label': 'เช็คสถานะเรียลไทม์',
    //               'uri': 'https://line.me/'
    //             }
    //           },
    //           {
    //             'type': 'box',
    //             'layout': 'vertical',
    //             'contents': [],
    //             'margin': 'sm'
    //           }
    //         ],
    //         'flex': 0
    //       }
    //     }
    //   }
    //   // let flex = {
    //   //   'type': 'text',
    //   //   'text': 'tessssssss'
    //   // }
    //   const result = await this.$liff.shareTargetPicker([
    //     flex
    //   ])
    //   if (result) {
    //     this.test = result.status
    //     // alert(`[${result.status}] Message sent!`)
    //   } else {
    //     this.test = 'false'
    //   }
    // },
    // async checkLiffLogin (dataLineConfig) {
    //   console.log('dataLineConfig', dataLineConfig)
    //   await this.$liff
    //     .init({
    //       liffId: dataLineConfig.liffMainID
    //     })
    //     .then(async () => {
    //       if (process.env.NODE_ENV === 'development') {
    //         this.getProfile_dev()
    //         // await this.shareFlex()
    //       } else {
    //         if (!this.$liff.isLoggedIn()) {
    //           this.$liff.login({ redirectUri: window.location.href })
    //         } else {
    //           await this.getProfile()
    //           await this.shareFlex()
    //         }
    //       }
    //     })
    //     .catch(err => {
    //       console.log(err.code, err.message)
    //     })
    // },
    // async getProfile () {
    //   let _this = this
    //   await this.$liff
    //     .getProfile()
    //     .then(function (profile) {
    //       _this.profile = profile
    //       console.log('prod', _this.profile)
    //     })
    //     .catch(function (error) {
    //       console.log('Error getting profile: ' + error)
    //     })
    // },
    // getProfile_dev () {
    //   this.profile = this.$profile_dev
    //   console.log('dev', this.profile)
    // }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Booking/ShareFlowStep.vue